import {type Message, type RawMessage, transformMessages} from '@/models/messageModel'
import type {Thread} from '@/models/threadModel'
import call from '@/utils/api/call'
import shouldLogError from '@/utils/api/shouldLogError'
import type {TextTopics} from '@/views/Chat/components/DefaultMessage/DefaultMessage'

export async function getTextTopics({signal}: {signal: AbortSignal}): Promise<TextTopics> {
  return call
    .get('/api/text_topics_with_category/', {
      signal,
    })
    .then(res => {
      // Verify data
      const textTopics: TextTopics = {}
      /* eslint-disable @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- its safe to access unsafe member because error is handled */
      if (Array.isArray(res.data?.find) && res.data?.find.length > 0)
        textTopics.find = res.data.find.map(String)
      if (Array.isArray(res.data?.explore) && res.data?.explore.length > 0)
        textTopics.explore = res.data.explore.map(String)
      if (Array.isArray(res.data?.deals) && res.data?.deals.length > 0)
        textTopics.deals = res.data.deals.map(String)
      /* eslint-enable @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- its safe to access unsafe member because error is handled */
      return textTopics
    })
    .catch(e => {
      if (shouldLogError(e)) {
        console.error('Cannot fetch text_topics_with_category', e)
      }
      return {} as TextTopics
    })
}

export async function getMessages({
  threadId,
  signal,
}: {
  threadId: Thread['id']
  signal: AbortSignal
}) {
  return call
    .get<RawMessage[]>(`/api/messages/${threadId}`, {
      signal,
    })
    .then(res => {
      return transformMessages(res.data.reverse())
    })
    .catch(e => {
      if (shouldLogError(e)) {
        console.error('Cannot fetch messages', e)
      }
      return [] as Message[]
    })
}

export async function feedbackMessage({
  messageId,
  action,
}: {
  messageId: Message['id']
  action: Message['action'] | 'delete'
}) {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- its safe to access unsafe member because error is handled
  const sendAction = action === null ? '' : action

  return call
    .post('/api/message_feedback/', {
      data: {
        message_id: messageId,
        action: sendAction,
      },
    })
    .then(() => {
      // empty
    })
    .catch(e => {
      if (shouldLogError(e)) {
        console.error('Cannot send message_feedback', e)
      }
    })
}
